import React from 'react';
import { useIntl } from 'react-intl';
import type { ArtistProfileBio } from 'fym-shared/src/music24/artistProfile';
import { TypedMemo } from '../../../../common/types';
import { profileBioMessages as b } from './profileBioMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** "Saved 17 Oct by Bartosz" (design c1), or "Saved." right after a save. */
const BioSavedLineComponent: React.FC<{ bio: ArtistProfileBio; savedNow: boolean }> = ({ bio, savedNow }) => {
  const intl = useIntl();
  if (savedNow) {
    return (
      <span className={styles.meta} role="status">
        {intl.formatMessage(b.savedNow)}
      </span>
    );
  }
  if (bio.updatedAt === null) {
    return null;
  }
  const date = intl.formatDate(bio.updatedAt, { day: 'numeric', month: 'short' });
  return (
    <span className={styles.meta} data-clarity-mask="true">
      {bio.updatedBy === null
        ? intl.formatMessage(b.savedAt, { date })
        : intl.formatMessage(b.savedBy, { date, name: bio.updatedBy.email })}
    </span>
  );
};

export const BioSavedLine = TypedMemo(BioSavedLineComponent);
